export const metabetRedirectionHandler = () => {
    const classValue = document.body.classList.value
    const classArray = classValue.split(' ')
    let extractedSport, extractedEdition

    classArray.forEach(className => {
        if (className.startsWith('path-')) {
            extractedSport = className.split('-')[1]
        }
        if (className.includes('-edition')) {
            extractedEdition = className.split('-')[0]
        }
    });


    if (!window.sn_entityRedirect) {
        window.sn_entityRedirect = function (entity) {
            const isTeamsPage = document.querySelector('.metabet-widget.metabet-betsinabox-teams')
            if ((entity["entity"] === "game" || entity["entity"] === "team") && !isTeamsPage) {
                entity["entity"] = "game"
                window.location.href = "/" + extractedEdition + "/" + extractedSport + "/" + entity["entity"] + "/" + entity["id"]
            }

            if (entity["entity"] === "team" && isTeamsPage) {
                window.location.href = "/" + extractedEdition + "/" + extractedSport + "/" + entity["entity"] + "/" + entity["id"]
            }
        }
    }
}
